<template>
	<v-menu :model-value="floatMenuModel.open" :target="[floatMenuModel.x, floatMenuModel.y]"
		:close-on-content-click="false">
		<v-card class="skip-spot-block-reason-container">
			<v-card-title class="text-h3 font-weight-bold">Select reason for skipping spot</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-form ref="floatMenuForm" :v-model="floatMenuForm.valid">
					<v-radio-group
						:v-model="floatMenuForm.skipType"
						class="mt-0"
						:rules="[(v) => !!v || 'Skip type is required']"
						hide-details>
						<v-radio v-for="type in listOfTypes"
							:key="type.value"
							:label="type.description"
							:value="type.value"
							:ripple="false"
						/>
					</v-radio-group>
					<v-text-field v-if="floatMenuForm.skipType === 6"
						:v-model="floatMenuForm.otherReasonComment"
						placeholder="Enter reason"
						:rules="[(v) => !!v || 'Reason is required']"
						class="mt-2"
						variant="outlined"
						density="compact"
						single-line
						hide-details
					></v-text-field>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn variant="outlined" color="primary" :disabled="floatMenuForm.loading"
					@click="$emit('close-menu')">
					Cancel
				</v-btn>
				<v-btn variant="flat" color="primary" :disabled="!floatMenuForm.valid || floatMenuForm.loading"
					:loading="floatMenuForm.loading" @click="submitEvent()">
					{{ nameButton }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	name: "SkipFloatMenu",

	props: {
		floatMenuModel: {
			type: Object,
			required: true,
		},

		floatMenuForm: {
			type: Object,
			required: true
		},

		listTypes: {
			type: Array
		},

		nameButton: {
			type: String,
			default() {
				return "Skip";
			}
		}
	},

	emits: ["close-menu", "submitEvent"],

	methods: {
		submitEvent() {
			if (this.$refs.floatMenuForm.validate()) {
				this.$emit("submitEvent", {skip: true, spot: true});
			}

		}
	},

	computed: {
		listOfTypes() {
			return this.listTypes;
		}
	},

	watch: {
		"floatMenuModel.open": function (newVal) {
			if (newVal) {
				this.$refs?.floatMenuForm?.reset();
			}
		},
	}
};
</script>
